<div class="fb-default-field-wrapper w-full">
  <div class="fb-field-label-container" *ngIf="!noLabel">
    <label
      *ngIf="label"
      class="fb-field-label"
      [class.disable-label]="ngControl?.control?.disabled && (_currentThemeSubject | async) === 'dark'"
    >
      {{ label }}
      <span class="required-asterisk" *ngIf="required">*</span>
    </label>
  </div>

  <div class="field-relative-container">
    <mat-form-field
      appearance="outline"
      class="w-full fb-custom-outline"
      [class.is-invalid]="ngControl?.control?.invalid && (ngControl?.control?.touched || ngControl?.control?.dirty)"
      [class.is-filled]="ngControl?.control?.value && (multiple ? ngControl?.control?.value?.length > 0 : true)"
    >
      <mat-select
        #matSelect
        disableOptionCentering
        [panelClass]="[
          (_currentThemeSubject | async) === 'dark' ? 'dark-theme-select-panel' : '',
          multiple ? 'multiple-custome-select-panel' : '',
          'custome-select-panel'
        ]"
        [required]="required"
        [formControl]="ngControl?.control"
        [fbDisableControl]="disable || readonly"
        [placeholder]="multiple ? '' : placeholder"
        [multiple]="multiple"
        [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
      >
        <mat-select-trigger
          *ngIf="multiple"
          class="t-body-text-regular custom-trigger-container"
          [class.dark-theme-color]="(_currentThemeSubject | async) === 'dark'"
          [class.light-theme-color]="(_currentThemeSubject | async) === 'light'"
        >
          <div class="trigger-content-wrapper">
            <span *ngIf="placeholder" class="trigger-label">{{ placeholder }}:</span>
            <span class="trigger-value">{{ selectedCounter }} select</span>
          </div>
        </mat-select-trigger>

        <div *ngIf="multiple && selectAll" class="d-flex pl-16 pr-16">
          <button class="add-item-button" (click)="toggleSelectAll()" matRipple>
            {{ selectAllButtonText }}
          </button>
        </div>

        <mat-option *ngFor="let option of options" [value]="option.value">
          <div class="d-flex">
            <div class="d-flex align-items-center" *ngIf="templates">
              <ng-container
                [ngTemplateOutlet]="[templates] | findTemplate : option.templateName"
                [ngTemplateOutletContext]="{
                  $implicit: {
                    config: option | transformFieldConfig : config
                  }
                }"
              ></ng-container>
            </div>
            <span
              [ngStyle]="{ color: option.color }"
              [class.dark-theme-color]="(_currentThemeSubject | async) === 'dark'"
              class="t-body-text-regular d-flex align-items-center ml-8"
              >{{ option.label }}</span
            >
          </div>
        </mat-option>
      </mat-select>
      <div matSuffix class="actions-suffix-container">
        <ng-container *ngIf="selectedCounter">
          <button
            tabindex="-1"
            type="button"
            mat-icon-button
            class="action-btn"
            (click)="onClear(); onTouched(); $event.stopPropagation(); $event.preventDefault()"
            [disabled]="disable || readonly || ngControl?.disabled"
          >
            <mat-icon [inline]="true" class="icon-button">clear</mat-icon>
          </button>

          <div class="action-divider"></div>
        </ng-container>

        <button
          type="button"
          mat-icon-button
          class="action-btn arrow-icon"
          (click)="
            matSelect.panelOpen ? matSelect.close() : matSelect.open();
            $event.stopPropagation();
            $event.preventDefault()
          "
          [disabled]="disable || readonly"
        >
          <mat-icon [inline]="true" class="icon-button">unfold_more</mat-icon>
        </button>
      </div>
    </mat-form-field>
    <div class="custom-empty-placeholder" *ngIf="multiple && !selectedCounter">
      <span *ngIf="placeholder" class="placeholder-label">{{ placeholder }}:&nbsp;</span>
      <span class="placeholder-value">Select</span>
    </div>
  </div>

  <div class="fb-field-subscript">
    <fb-validation-error
      *ngIf="ngControl?.control?.invalid && (ngControl?.control?.touched || ngControl?.control?.dirty)"
      [control]="ngControl?.control"
      [label]="label"
    ></fb-validation-error>
  </div>
</div>
